import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import { Archive2022 } from '../ScintillaOfArt/components';
import Sidebar2026 from '../SEWA/components/Sidebar2026/Sidebar2026';


const Ayurveda2026 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });


    const [config, setConfig] = useState({ base_image_url_2025: '' });
    useEffect(() => {
        fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
            .then(response => response.json())
            .then(data => setConfig(data))
            .catch(error => console.error('Error fetching config:', error));
    }, []);

    const p1 = `${config.base_image_url_2025}/home/events-activities/sewa/Ayurveda/1.webp`;
    const p2 = `${config.base_image_url_2025}/home/events-activities/sewa/Ayurveda/2.webp`;
    const p3 = `${config.base_image_url_2025}/home/events-activities/sewa/Ayurveda/3.webp`;
    const p4 = `${config.base_image_url_2025}/home/events-activities/sewa/Ayurveda/4.webp`;
    const p5 = `${config.base_image_url_2025}/home/events-activities/sewa/Ayurveda/5.webp`;
    const p6 = `${config.base_image_url_2025}/home/events-activities/sewa/Ayurveda/6.webp`;
    

    const photos = [
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        },
        {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },
        {
            src: p5,
            source: p5,
            rows: 1,
            cols: 1,
        },
        {
            src: p6,
            source: p6,
            rows: 1,
            cols: 1,
        }

    ];

    return (
         <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            
                            <Box >
                                <Typography variant='h4' align='center' >
                                    <div>AYURVEDA − A holistic approach to health and wellness  </div>
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                 Class: 10     Date: 4 April 2026
                                </Typography>
                             
                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                               The session titled ‘Ayurveda: A Holistic Approach to Health and Wellness’ was conducted by the alumni of NPS Yeshwanthpur, Dr.Sampada Joshi on Saturday, April 4 2026. This session aimed to introduce the students of class 10 to the Ancient Indian System of Medicine and its relevance in the modern world. The core objective was to educate the attendees on how to achieve harmony between the mind, body and spirit through preventive care, mindful eating and daily routines.
                               <br></br>
                               A major segment of the session  was dedicated to the three vital energies or Doshas that govern the physiological and psychological functions of our body, namely - Vata (Space & Air) linked to movement, creativity and the nervous system ; Pitta (Fire & Water)linked to digestion, metabolism, and intelligence and Kapha (Earth & Water) Linked to structure, immunity, and stability. 
                               <br></br>
                               The session successfully demystified Ayurveda, presenting it not just as an alternative medical system, but as a practical, everyday lifestyle guide. The students left with actionable insights to take charge of their own health through simple dietary and routine adjustments.
                                    <br></br>
                                </Typography>
                            </Box>
                                <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “AYURVEDA- THE ART OF MINDFUL LIVING ”

                                <br />
                            </Typography>
                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 300 : 200}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2026/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>


    );
};

export default Ayurveda2026;